import { render, staticRenderFns } from "./FilesPane.vue?vue&type=template&id=58313e3c&scoped=true"
import script from "./FilesPane.vue?vue&type=script&lang=js"
export * from "./FilesPane.vue?vue&type=script&lang=js"
import style0 from "./FilesPane.vue?vue&type=style&index=0&id=58313e3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58313e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58313e3c')) {
      api.createRecord('58313e3c', component.options)
    } else {
      api.reload('58313e3c', component.options)
    }
    module.hot.accept("./FilesPane.vue?vue&type=template&id=58313e3c&scoped=true", function () {
      api.rerender('58313e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/FilesPane.vue"
export default component.exports